export enum HOMEPAGE_DIALOG {
    DELETE_ENTITY = "DELETE_ENTITY",
    MOVE_ENTITY = "MOVE_ENTITY",
    DUPLICATE_ENTITY = "DUPLICATE_ENTITY"
} 